// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import Loading from 'components/loading/loading';

const ReCalculation = lazy(() => import('pages/recalculation/index'));

const RecalculationRoute = (
  <Route path={routeName.recalculation}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.PAYOUTREVIEWER_DASHBOARD,
            PrivateRouteConst.MY_TASK,
            PrivateRouteConst.MY_TASK_DASHBOARD,
            PrivateRouteConst.PAYOUT_ADMIN,
          ]}
        >
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <ReCalculation />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default RecalculationRoute;
